module.exports = __webpack_public_path__ + "static/media/Divorce.904d71e9.png";